<div class="pt-4">
  <app-base-table
    [tableConfig]="tableConfig"
    [dataTable]="revisionHistory"
    [paginator]="false"
  ></app-base-table>
  <div class="mt-5 flex flex-row justify-content-end">
    <app-base-button
      class="flex mr-3 align-self-end"
      label="CLOSE"
      (onClick)="closeModal()"
    >
    </app-base-button>
  </div>
</div>
